import * as Sentry from "@sentry/browser";
import { REACT_APP_PROD_URL } from "../services/configs";
import store from "../redux/store";
import axios from "axios";

// import fetcher from "../../../actions/_api";

const fetcher = async (endpoint, params = {}) => {
  // const { store } = configureStore();
  const state = store.getState();

  // (method = "GET"), (body = false), (headers = {}), (type = false);
  var token = state.trading.TOKEN;
  var bearer = "Bearer " + token;

  const res = await fetch(REACT_APP_PROD_URL + endpoint, {
    method: params.method || "GET",
    ...(Boolean(params.body) && {
      body:
        params.type == "formData" ? params.body : JSON.stringify(params.body),
    }),
    headers: {
      Authorization: bearer,

      ...(Boolean(params.type != "formData") && {
        "Content-Type": "application/json",
      }),

      "access-control-allow-origin": "*",
      "Access-Control-Allow-Credentials": true,
      ...params.headers,
    },
  });

  // If the status code is not in the range 200-299,
  // we still try to parse and throw it.
  if (endpoint === "/v1/account") {
    if (res.status === 401 && Boolean(token)) {
      store.dispatch({ type: "SET_TOKEN_STATUS", payload: res.status });
    } else {
      store.dispatch({ type: "SET_TOKEN_STATUS", payload: null });
    }
  }

  if (!res.ok) {
    const error = new Error("An error occurred while fetching the data.");
    // Attach extra info to the error object.
    error.info = await res.json();
    error.status = res.status;

    throw error;
  }

  switch (params.type) {
    case "text":
      return res.text();
    default:
      return res.json();
  }
};

export default fetcher;
